"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextHelp = void 0;
const remark_gfm_1 = __importDefault(require("remark-gfm"));
const React = __importStar(require("react"));
const react_markdown_1 = __importDefault(require("react-markdown"));
const HelpOutline_1 = __importDefault(require("@material-ui/icons/HelpOutline"));
const tooltip_1 = require("../tooltip/tooltip");
const context_help_styles_1 = require("./context-help-styles");
function ContextHelp({ label, type = 'CLICKABLE' }) {
    const { root } = (0, context_help_styles_1.useStyles)();
    if (label === undefined || label === ' ') {
        return React.createElement(React.Fragment, null);
    }
    else {
        const content = (React.createElement(react_markdown_1.default, { linkTarget: "_blank", remarkPlugins: [remark_gfm_1.default] }, label !== null && label !== void 0 ? label : ''));
        return (React.createElement(tooltip_1.Tooltip, { title: content, placement: "top-start", type: type },
            React.createElement(HelpOutline_1.default, { className: root }),
            ";"));
    }
}
exports.ContextHelp = ContextHelp;
//# sourceMappingURL=context-help.js.map